<p-dialog [(visible)]="showaddUpdateModal" [position]="'center'" [modal]="true" [dismissableMask]="false" [closeOnEscape]="false"
    [style]="{width:'50rem'}" styleClass="dark-bank-dialog">
    <ng-template pTemplate="header">
        <h5>{{ context === 'edit' ? 'Edit Bank account' : 'Add Bank account' }}</h5>
    </ng-template>
    <ng-template pTemplate="content">
        <app-bank-add [currentBank]="currentSelectedBank" [customerData]="customerData?.accountId"
            (changeModalStatus)="changeAddUpdateModelState($event)" [context]="context"></app-bank-add>
    </ng-template>
</p-dialog>

<app-bank-list [bankListData]="bankAccountList" 
    (changeModalStatus)="changeAddUpdateModelState($event)"
    (deleteBankAccount)="onDeleteBankAccount($event)">
</app-bank-list>